import { Col, Label, Row } from "reactstrap";
import { Checkbox, RadioGroup } from "../../../common/VFX-UI";
import { getFormattedCurrency } from "../../../../utility/helpers";
import { CHECK_ID, CREDIT_CARD_ID, PAYROLL_REDUCTION_ID } from "../constants";
import { Options } from "../../../../types";
import usePledgeStyles from "../styles";

interface PaymentMethodSectionProps {
    show: boolean;
    values: {
        paymentOptionId: string | null;
        contributionAmount: number | null;
    };
    paymentOptions: Options[];
    pledgeStyles: ReturnType<typeof usePledgeStyles>;
    paymentCreditCardEnabled: boolean;
    paymentCheckEnabled: boolean;
    paymentPayrollDeductionEnabled: boolean;
}

const PaymentMethodSection = (props: PaymentMethodSectionProps) => {
    const paymentOptionEnabled: Record<string, boolean> = {
        [CHECK_ID]: props.paymentCheckEnabled,
        [CREDIT_CARD_ID]: props.paymentCreditCardEnabled,
        [PAYROLL_REDUCTION_ID]: props.paymentPayrollDeductionEnabled,
    };
    const permittedPaymentOptions = props.paymentOptions.filter(
        (option) => paymentOptionEnabled[option.value] === true
    );

    return (
        <>
                                    <Row>
                                        <Label style={props.pledgeStyles.sectionHeader} className="border-bottom mb-3 pb-2">2. Choose a payment method</Label>
                                        {!props.show && <Col xs={12}><div className="mb-3 p-3" style={{ backgroundColor: "#f7f8f9", borderRadius: 6, color: "#5f6b73" }}>Choose your contribution first to see the available payment methods.</div></Col>}
                                        {props.show && (
                                            <Col sm={12} lg={7}>
                                                <RadioGroup
                                                    options={permittedPaymentOptions}
                                                    name="paymentOptionId"
                                                    onChange={() => { }}
                                                />
                                                {props.values.paymentOptionId === CREDIT_CARD_ID && (
                                                    <div className="ms-4">
                                                        <Checkbox
                                                            label={`I authorize 12 monthly payments of ${getFormattedCurrency(
                                                                Number(((props.values.contributionAmount ?? 0) / 12).toFixed(2))
                                                            )}.`}
                                                            name="isRecurringContribution"
                                                        />
                                                    </div>
                                                )}
                                                {props.values.paymentOptionId === CHECK_ID && (
                                                    <div style={{ marginLeft: "10px" }}>
                                                        <div>
                                                            <b>Mail Check to:</b>
                                                        </div>
                                                        <div>Capital Area United Way</div>
                                                        <div>700 Laurel Street</div>
                                                        <div>Baton Rouge, LA 70802</div>
                                                    </div>
                                                )}
                                            </Col>
                                        )}
                                    </Row>
        </>
    );
};

export default PaymentMethodSection;
